import React from "react";

import { SliderProps } from "./Slider.types";

import "./Slider.scss";

const Slider: React.FC<SliderProps> = ({ value, onChange, min, max, step }) => (
  <input
    className="mp-atoms-slider--main"
    type="range"
    min={min}
    max={max}
    step={step}
    value={value}
    onChange={onChange}
  />
);

export default Slider;
